var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 5.77778c0-.4715.1873-.92368.5207-1.25708s.78558-.5207 1.25708-.5207h2.91555c.18649.00014.3682.05893.51943.16804.15123.10912.26431.26303.32324.43996l1.3316 3.99378c.0674.20297.0594.42346-.0225.62102-.082.19756-.2324.35894-.4238.45453l-2.00619 1.00447c.9834 2.1765 2.72659 3.9197 4.90309 4.9031l1.0045-2.0062c.0956-.1914.2569-.3418.4545-.4238.1976-.0819.4181-.0899.621-.0225l3.9938 1.3316c.1771.059.3311.1722.4402.3236s.1678.3333.1678.52v2.9146c0 .4715-.1873.9237-.5207 1.2571s-.7856.5207-1.2571.5207h-.8889c-7.36352 0-13.3333-5.9698-13.3333-13.33333z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.731e1e07b0bd5df30c6a61047f421c2e.svg";
export { ForwardRef as ReactComponent };